<template>
  <div class="case-creation__step case-creation__Case-information">
    <div class="case-creation__card">
      <div class="case-creation__heading edit-view">
        <div class="title-with-icon">
          <span class="icon">
            <img
              src="@/assets/images/icons/icon-case-info.svg"
              alt="icon"
              class="img-fluid"
            />
          </span>
          <h3 class="title">Case Information</h3>
        </div>
      </div>
      <div class="case-creation__body pb-0" v-loading="loading">
        <el-row :gutter="15">
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div
              class="input-value view-cases"
              v-if="getCaseInformation && getCaseInformation.case_types"
            >
              <h4 class="name">Case Type</h4>
              <ul>
                <li
                  v-for="(caseType, index) of getCaseInformation.case_types"
                  :key="index"
                >
                  {{
                    getCaseInformation &&
                    getCaseInformation.is_mileage_case &&
                    ($route.name == "MilageCaseView" ||
                      $route.name == "Mileage-Case-Information-Update")
                      ? "Mileage"
                      : caseTypeMap[caseType]
                  }}
                </li>
              </ul>
            </div>
          </el-col>
          <el-col
            :xl="3"
            :lg="4"
            :md="8"
            :sm="12"
            :xs="12"
            v-if="getCaseInformation?.is_stat && !showStatCase()"
          >
            <div class="input-value view-cases">
              <h4 class="name">STAT Case</h4>
              <p
                class="value"
                style="
                  background: #bf1b39;
                  width: 42px;
                  height: 18px;
                  border-radius: 10px;
                  padding-left: 14px;
                  color: white;
                "
                v-if="getCaseInformation && getCaseInformation?.is_stat"
              >
                Yes
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Laboratory</h4>
              <p
                class="value"
                v-if="getCaseInformation && getCaseInformation.lab"
              >
                {{ getCaseInformation.lab.name }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div
              class="input-value view-cases"
              v-if="getCaseInformation && getCaseInformation.collection_date"
            >
              <h4 class="name">Collection Date</h4>
              <p class="value">
                {{
                  momentWithTimezoneTime(
                    getCaseInformation.collection_date,
                    "MM-DD-yyyy hh:mm A",
                    getCaseInformation?.timezone
                  )
                }}
              </p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div
              class="input-value view-cases"
              v-if="getCaseInformation && getCaseInformation.received_date"
            >
              <h4 class="name">Received Date</h4>
              <p class="value">
                {{
                  momentWithTimezoneTime(
                    getCaseInformation.received_date,
                    "MM-DD-yyyy hh:mm A",
                    getCaseInformation?.timezone
                  )
                }}
              </p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Ordering Facility</h4>
              <p
                class="value"
                v-if="getCaseInformation && getCaseInformation.hospital"
              >
                {{ getCaseInformation.hospital.name }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>

          <el-col
            :xl="3"
            :lg="4"
            :md="8"
            :sm="12"
            :xs="12"
            v-if="!isBillingUser"
          >
            <div class="input-value view-cases">
              <h4 class="name">Ordering Facility State</h4>
              <p
                class="value"
                v-if="getCaseInformation && getCaseInformation.hospital"
              >
                {{ getCaseInformation.hospital.state }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Ordering Physician</h4>
              <p
                class="value"
                v-if="
                  getCaseInformation && getCaseInformation.ordering_physician
                "
              >
                {{ getCaseInformation.ordering_physician.first_name + " " + getCaseInformation.ordering_physician.last_name }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col
            :xl="3"
            :lg="4"
            :md="8"
            :sm="12"
            :xs="12"
            v-if="!isBillingUser"
          >
            <div class="input-value view-cases">
              <h4 class="name">Ordering Physician NPI</h4>
              <p
                class="value"
                v-if="
                  getCaseInformation && getCaseInformation.physician_npi
                "
              >
                {{ getCaseInformation.physician_npi.npi_code }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Bill To</h4>
              <p
                class="value"
                v-if="getCaseInformation && getCaseInformation.billing_type"
              >
                {{ getCaseInformation.billing_type }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Order ID</h4>
              <p
                class="value"
                v-if="getCaseInformation && getCaseInformation.testgo_order_id"
              >
                {{ getCaseInformation.testgo_order_id }}
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
          <el-col :xl="10" :lg="10" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases icd-codes">
              <div class="indicatives">
                <h4 class="name">ICD-10 (Indicative)</h4>
                <ul
                  v-if="getCaseInformation && getCaseInformation.icd_10_codes"
                >
                  <li
                    class="value"
                    v-for="(
                      icd_10_code, index
                    ) in getCaseInformation.icd_10_codes"
                    :key="index"
                  >
                    {{ icd_10_code }}
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
          <el-col :xl="6" :lg="12" :md="12">
            <div class="input-value view-cases">
              <div
                class="speciment-type-view"
                v-if="getCaseInformation && getCaseInformation.sample_types"
              >
                <div>
                  <h4 class="name">Specimen Types</h4>
                  <ul
                    class="case_type"
                    v-if="
                      getCaseInformation.sample_types &&
                      getCaseInformation.sample_types.length
                    "
                  >
                    <li
                      class="value"
                      v-for="(
                        sampleType, index
                      ) in getCaseInformation.sample_types"
                      :key="index"
                    >
                      {{ caseTypeMap[sampleType.case_type] }}
                    </li>
                  </ul>
                  <ul v-else>
                    --
                  </ul>
                </div>
                <div>
                  <h4 class="name">&nbsp;</h4>

                  <ul
                    class="speciment_type"
                    v-if="
                      getCaseInformation.sample_types &&
                      getCaseInformation.sample_types.length
                    "
                  >
                    <li
                      v-for="(
                        sampleType, index
                      ) in getCaseInformation.sample_types"
                      :key="index"
                    >
                      <span
                        v-if="
                          sampleType.sample_types &&
                          sampleType.sample_types.length
                        "
                      >
                        <span
                          v-for="(sample, index) in sampleType.sample_types"
                          :key="index"
                        >
                          {{ sample }}
                          <span
                            v-if="index + 1 < sampleType.sample_types.length"
                            >,</span
                          >
                        </span>
                      </span>
                      <span v-else> -- </span>
                    </li>
                  </ul>
                  <ul v-else>
                    --
                  </ul>
                </div>
              </div>
            </div>
          </el-col>
          <el-col
            :xl="6"
            :lg="12"
            :md="12"
            v-if="
              this.getCaseInformation &&
              this.getCaseInformation.sample_types &&
              this.getCaseInformation.sample_types.length > 0 &&
              this.getCaseInformation.sample_types.some(
                (item) => item.case_type === 'WOUND'
              )
            "
          >
            <div class="input-value view-cases">
              <div
                class="speciment-type-view"
                v-if="getCaseInformation && getCaseInformation.sample_types"
              >
                <div>
                  <h4 class="name">Specimen Source</h4>
                  <p
                    v-if="
                      this.getCaseInformation &&
                      this.getCaseInformation.specimen_source &&
                      this.getCaseInformation.specimen_source.length
                    "
                    class="value"
                  >
                    {{ this.getCaseInformation.specimen_source }}
                  </p>
                  <p v-else>--</p>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xl="6" :lg="8" :md="8" :sm="8" :xs="8" v-if="!isBillingUser">
            <div class="input-value view-cases cpt-codes">
              <div class="indicatives">
                <h4 class="name">CPT Codes</h4>
                <ul
                  v-if="
                    getCaseInformation &&
                    getCaseInformation.cpt_codes &&
                    getCaseInformation.cpt_codes.length
                  "
                >
                  <li
                    v-for="(cpt_code, index) in getCaseInformation.cpt_codes"
                    :key="index"
                  >
                    {{ cpt_code }}
                  </li>
                </ul>
                <ul v-else>
                  --
                </ul>
              </div>
            </div>
          </el-col>
          <el-col
            :xl="3"
            :lg="3"
            :md="3"
            :sm="3"
            :xs="3"
            v-if="
              hadClinicalChemistry &&
              (getCaseInformation.is_fasting == false ||
                getCaseInformation.is_fasting == true) &&
              getCaseInformation.order_id
            "
          >
            <div class="input-value view-cases">
              <h4 class="name">Fasting</h4>
              <p class="value">
                {{ getCaseInformation.is_fasting ? "Yes" : "No" }}
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
export default {
  mixins: [UserPermissionsHelper],
  computed: {
    ...mapGetters("cases", [
      "getCaseInformation",
    ]),
    hadClinicalChemistry() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.case_types &&
        this.getCaseInformation.case_types.indexOf("CLINICAL_CHEMISTRY") > -1
      ) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      sampleTypes: [],
      loading: false,
    };
  },
  async mounted() {
    this.getSampleTypes();
  },
  methods: {
    getSampleTypes() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.sample_types &&
        this.getCaseInformation.sample_types.length
      ) {
        for (let i = 0; i < this.getCaseInformation.sample_types.length; i++) {
          this.sampleTypes.push(
            this.getCaseInformation.sample_types[i].sample_types
          );
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.icd-codes {
  .indicatives {
    ul {
      display: flex;
      li {
        margin: 0 6px;
        p {
          .value {
            padding: 3px 12px !important;
          }
        }
      }
    }
  }
}
.cpt-codes {
  .indicatives {
    ul {
      display: flex;
      row-gap: 10px;
      li {
        margin: 0 5px;
        width: 45px;
        text-align: center;
        p {
          .value {
            padding: 3px 12px !important;
          }
        }
      }
    }
  }
}
</style>
